export default __webpack_public_path__ + "static/media/Group 42.390cb294.png";